import { Controller } from "@hotwired/stimulus"

// Removes ?token= (and &token=) from the browser URL bar after page load
// so the JWT token is not visible or bookmarkable.
export default class extends Controller {
  connect() {
    if (!history.replaceState) return

    const cleaned = location.pathname +
      location.search.replace(/[?&]token=[^&]+/, '').replace(/^&/, '?')

    history.replaceState(null, '', cleaned)
  }
}
